import { AppActions } from '../actions';

const initialState = {
  // 1回のツイートあたりのインプレッション数
  resultImpression: 0,
  // インプレッションあたりのプロフィール閲覧率
  resultProfile: 0,
  // プロフィール閲覧あたりの新規フォロワー率
  resultNewFollower: 0,
  // 何回ツイートすればいいのか
  resultTweet: 0,
  // 1000フォロワー超えているか
  isOver1000Follower: false,
};

export default function AppReducer(state = initialState, action) {
  switch (action.type) {
    case AppActions.SET_RESULT:
      return {
        ...state, 
        resultImpression: action.payload.resultImpression,
        resultProfile: action.payload.resultProfile,
        resultNewFollower: action.payload.resultNewFollower,
        resultTweet: action.payload.resultTweet,
        isOver1000Follower: action.payload.isOver1000Follower,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/AppReducer.js